import { Component, Vue } from 'vue-property-decorator';
import { SelectOption } from '@/types/types';
import { ContactFields } from '@/types/graphql/schemaTypes';

// gql
import fetchCustomerContact from '@/graphql/queries/FetchCustomerContact.gql';

@Component({
  apollo: {
    contactOptions: {
      query: fetchCustomerContact,
      debounce: 300,
      skip() {
        return !this.customerOrganization?.id;
      },
      variables() {
        return {
          contactArgs: {
            customerOrganizationId: this.customerOrganization.id,
            name: this.searchContact
          }
        };
      },
      update(data): SelectOption<ContactFields>[] {
        return [{
          value: '新規で登録する',
          label: this.searchContact,
          isCreation: true
        }, ...data.contacts.map(this.formatContactOptions)];
      }
    }
  }
})

export default class ContactOptionsMixin extends Vue {
  public contactOptions: SelectOption<ContactFields>[] = [];
  public searchContact = '';

  public formatContactOptions(contact: ContactFields) {
    return {
      label: contact.name,
      value: contact
    };
  }
}
